import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {confirm} from "../../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import {addGlobalError} from "../../../../actions/globalerror";
import config from "../../../../../../server/src/config";

class Pigeons extends React.Component {
    static propTypes = {
        data: PropTypes.array.isRequired,
        setEditMode: PropTypes.func.isRequired,
        updateRow: PropTypes.func.isRequired,
        deleteRow: PropTypes.func.isRequired,
        acceptRow: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            editIx: null,
        };
    }

    fields = [];
    render() {
        return <div>
            <table className="data-table">
                <thead>
                <tr>
                    <th></th>
                    <th>Fejltekst</th>
                    <th className="center">Foren</th>
                    <th className="center">Slag</th>
                    <th>Ringnr.</th>
                    <th className="center">Aktiv</th>
                    <th className="center">Køn</th>
                    <th>Vacc.dato</th>
                    <th>Vacc.kontrollant</th>
                    <th>Vers.</th>
                </tr>
                </thead>
                <tbody>
                {this.props.data.map((row, ix) => ix === this.state.editIx ? <tr key={ix} className="edit-row">
                    <th scope="row" style={{minWidth: '80px'}}>
                        <i className="fa fa-save clickable" title="Gem station" onClick={() => {
                            if (this.allInputValid()) {
                                this.props.updateRow({
                                    Foreningsnr: row.Foreningsnr,
                                    Ringnummer: row.Ringnummer,
                                }, {
                                    Foreningsnr: this.state.Foreningsnr === '' ? null : this.state.Foreningsnr,
                                    Slagnr: this.state.Slagnr === '' ? null : this.state.Slagnr,
                                    Ringnummer: this.state.Ringnummer === '' ? null : this.state.Ringnummer,
                                    Aktiv: this.state.Aktiv,
                                    Koen: this.state.Koen === '' ? null : this.state.Koen,
                                    VaccDato1: this.state.VaccDato1 === '' ? null : moment(this.state.VaccDato1, config.formats.dateFormat).format('YYYY-MM-DD'),
                                    VaccKontrollant1: this.state.VaccKontrollant1 === '' ? null : this.state.VaccKontrollant1,
                                }, () => {
                                    NotificationManager.success("Urnummer " + String(this.state.Urnr) + " for slag " + this.state.Slagnr + " i forening " + this.state.Foreningsnr + " er opdateret.", "Opdatering", 4000);
                                    this.setState({editIx: null});
                                    this.props.setEditMode(false);
                                });
                            } else {
                                this.fields.forEach((field) => {
                                    field.setState({visited: true});
                                });
                            }
                        }}/>
                        <i className="fa fa-undo clickable" title="Annuller" onClick={() => {
                            this.setState({editIx: null});
                            this.props.setEditMode(false);
                        }}/>
                    </th>
                    <td>{row.Fejltekst === null ? '' : row.Fejltekst}</td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Foreningsnr" id="Foreningsnr" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Foreningsnr}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[0] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Slagnr" id="Slagnr" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Slagnr}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[1] = instance; }}
                        />
                    </td>
                    <td style={{minWidth: '100px'}}>
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field150" containerClassName="display-inline-block"
                                          name="Ringnummer" id="Ringnummer" maxLength="11" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}\\-[0-9]{2}\\-[0-9]{4}"}]} value={this.state.Ringnummer}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[2] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <input type="checkbox" name="Aktiv" id="Aktiv" checked={this.state.Aktiv === 'X' || this.state.Aktiv === 'x'} onChange={(e) => {
                            this.setState({Aktiv: e.target.checked ? 'X' : null});
                        }}/>
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Koen" id="Koen" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[AUX]"}]} value={this.state.Koen}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onUpperCaseFieldChange}
                                          ref={instance => { this.fields[3] = instance; }}
                        />
                    </td>
                    <td>
                        <UserFieldElement dataType={UserFieldDataType.date} placeholder="" className="field125" containerClassName="display-inline-block"
                                          name="VaccDato1" id="VaccDato1" maxLength="10" value={this.state.VaccDato1}
                                          autoCheckErrors={true} required={false} hideErrWhenFocused={false} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[4] = instance; }}
                        />
                    </td>
                    <td>
                        <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field200" containerClassName="display-inline-block"
                                          name="VaccKontrollant1" id="VaccKontrollant1" maxLength="25" value={this.state.VaccKontrollant1}
                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[5] = instance; }}
                        />
                    </td>
                    <td>{row.Programversion === null ? '' : row.Programversion}</td>
                </tr> : <tr key={ix}>
                    <th scope="row" style={{minWidth: '80px'}}>
                        <i className={"fa fa-pencil " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Rediger række" onClick={() => {
                            if (this.state.editIx === null) this.setState({
                                Foreningsnr: row.Foreningsnr === null ? '' : row.Foreningsnr,
                                Slagnr: row.Slagnr === null ? '' : row.Slagnr,
                                Ringnummer: row.Ringnummer === null ? '' : row.Ringnummer,
                                Aktiv: row.Aktiv,
                                Koen: row.Koen === null ? '' : row.Koen,
                                VaccDato1: row.VaccDato1 === null ? '' : moment(row.VaccDato1).format(config.formats.dateFormat),
                                VaccKontrollant1: row.VaccKontrollant1 === null ? '' : row.VaccKontrollant1,
                                editIx: ix,
                            });
                            this.props.setEditMode(true);
                        }}/>
                        <i className={"fa fa-trash " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Slet række" onClick={() => {
                            if (this.state.editIx === null) confirm("Slet", <span>Ønsker du at slette ringnummer <b>{row.Ringnummer}</b> for slag <b>{row.Slagnr}</b> i forening <b>{row.Foreningsnr}</b>?</span>, () => {
                                this.props.deleteRow([{
                                    Foreningsnr: row.Foreningsnr,
                                    Ringnummer: row.Ringnummer,
                                }], () => {
                                    NotificationManager.success("Ringnummer " + String(row.Ringnummer) + " for slag " + row.Slagnr + " i forening " + row.Foreningsnr + " er slettet.", "Sletning", 4000);
                                });
                            });
                        }}/>
                        <i className={"fa fa-check " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Accepter række" onClick={() => {
                            if (this.state.editIx === null) confirm("Accepter", <span>Ønsker du at acceptere ringnummer <b>{row.Ringnummer}</b> for slag <b>{row.Slagnr}</b> i forening <b>{row.Foreningsnr}</b>?</span>, () => {
                                this.props.acceptRow([{
                                    Foreningsnr: row.Foreningsnr,
                                    Ringnummer: row.Ringnummer,
                                }], (response) => {
                                    if (response.failed.length > 0) this.props.dispatch(addGlobalError('Fejl ved accept', response.failed[0].msg, -1));
                                    else NotificationManager.success("Ringnummer " + String(row.Ringnummer) + " for slag " + row.Slagnr + " i forening " + row.Foreningsnr + " er accepteret.", "Accept", 4000);
                                });
                            });
                        }}/>
                    </th>
                    <td>{row.Fejltekst === null ? '' : row.Fejltekst}</td>
                    <td className="center">{row.Foreningsnr === null ? '' : row.Foreningsnr}</td>
                    <td className="center">{row.Slagnr === null ? '' : row.Slagnr}</td>
                    <td>{row.Ringnummer === null ? '' : row.Ringnummer}</td>
                    <td className="center">{row.Aktiv === null ? '' : row.Aktiv}</td>
                    <td className="center">{row.Koen === null ? '' : row.Koen}</td>
                    <td>{row.VaccDato1 === null ? '' : moment(row.VaccDato1).format(config.formats.dateFormat)}</td>
                    <td>{row.VaccKontrollant1 === null ? '' : row.VaccKontrollant1}</td>
                    <td>{row.Programversion === null ? '' : row.Programversion}</td>
                </tr>)}
                </tbody>
            </table>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onUpperCaseFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value.toUpperCase()});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getAllKeys = () => {
        return this.props.data.map(row => ({
            Foreningsnr: row.Foreningsnr,
            Ringnummer: row.Ringnummer,
        }));
    };
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, null, null, {withRef: true})(Pigeons);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/errorLists/subPages/Pigeons.js